import { render, staticRenderFns } from "./PersonsView.vue?vue&type=template&id=07aeae6f&scoped=true"
import script from "./PersonsView.vue?vue&type=script&lang=js"
export * from "./PersonsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aeae6f",
  null
  
)

export default component.exports